import { LoaderIcon } from 'lucide-react';
import { cn } from '@web/lib/shadcn';

interface SpinnerProps {
  className?: string;
}

export function Spinner({ className }: SpinnerProps) {
  return (
    <div className={cn("grid h-full w-full place-content-center self-center", className)}>
      <LoaderIcon className="animate-spin" />
    </div>
  );
}
